<template>
  <v-app-bar style="background-color: #232D3F;" elevation="0" fixed :height="$vuetify.breakpoint.xl ? 96 : 64">
    <v-toolbar-title>
      <div @click="checkForUpdate()">
        <v-img :src="imageUrl" max-height="80" max-width="100" contain class="align-self-stretch"></v-img><span
          class="white--text text-caption" v-if="getWrapperVersion">v {{ getWrapperVersion }}</span>
      </div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-list-item two-line class="px-0 ml-5" v-if="signedIn">
      <div class="mr-2" v-if="signedIn">
        <v-btn elevation="0" :x-large="$vuetify.breakpoint.xl" color="blue-grey lighten-1" @click="signOut"
          class="signout white--text">Sign <br />out</v-btn>
      </div>
      <v-btn elevation="0" :x-large="$vuetify.breakpoint.xl" color="black lighten-1" @click="showAddTransModal = true"
        class="signout white--text mr-2"><v-icon :x-large="$vuetify.breakpoint.xl"
          class="white--text">mdi-cash-register</v-icon></v-btn>
      <v-btn v-if="hasFeature('accDeposits') && accDepsOn" elevation="0" :x-large="$vuetify.breakpoint.xl" color="black lighten-1" @click="showFundChangeModal = true"
        class="signout white--text mr-2"><v-icon :x-large="$vuetify.breakpoint.xl"
        class="white--text">mdi-cash</v-icon></v-btn>
      <v-btn elevation="0" :x-large="$vuetify.breakpoint.xl" color="black lighten-1"
        @click="showTransHistoryModal = true" class="signout white--text" :disabled="false"><v-icon
          :x-large="$vuetify.breakpoint.xl" class="white--text">mdi-currency-usd-circle-outline</v-icon></v-btn>
      <div class="ml-2" v-if="signedIn && callAttendantOn">
        <v-btn v-if="!isAttendantCalled" elevation="0" :x-large="$vuetify.breakpoint.xl" color="blue-grey lighten-1" @click="callAttendant"
               class="signout white--text"><v-icon
          :x-large="$vuetify.breakpoint.xl" class="white--text">mdi-bell-outline</v-icon></v-btn>
        <v-btn v-else-if="isAttendantCalled" elevation="0" :x-large="$vuetify.breakpoint.xl" color="warning" @click="cancelCallAttendant"
               class="signout white--text">Cancel Call</v-btn>
      </div>
      <v-list-item-avatar class="mx-xl-4 ">
        <v-icon :large="$vuetify.breakpoint.xl" class="white--text">mdi-account-check</v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="white--text">
        <v-list-item-title class="text-xl-subtitle-1 text-body-2">Terminal: {{ getTerminalLocation }}</v-list-item-title>
        <v-list-item-subtitle class="white--text text-xl-subtitle-1 text-body-2"><span v-if="getTerminalBranch">Branch: {{
          getTerminalBranch }}</span>
          User: {{ userName }}</v-list-item-subtitle>
        <v-list-item-subtitle class="white--text d-flex text-xl-subtitle-1 text-body-2">Current
          <v-icon :small="$vuetify.breakpoint.xl" :x-small="!$vuetify.breakpoint.xl"
            class="white--text mx-1">mdi-clock-outline</v-icon>
          {{ setNewTime }}
          <v-chip class="ml-2" :color="isOnline ? '#4caf50' : 'red'" x-small v-if="netStatusOn">
            <v-icon v-if="isOnline" x-small left color="white">
              mdi-wifi
            </v-icon>
            <v-icon v-else x-small left color="white"> mdi-wifi-off </v-icon>
            <span class="white--text">{{
              isOnline ? "Online" : "Offline"
            }}</span>
          </v-chip>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <!--<v-btn elevation="0" color="error" dark @click="clickAppAuth(true)" class="mr-2">
      Authenticate
    </v-btn>-->
    <MultiScannedTicketsModal v-if="getMultiRedemptionMode" @onManualScan="clickScan" :loadingTicket="loadingTicket">
    </MultiScannedTicketsModal>
    <ScannedTicketModal v-if="showThisScannedTicketModal" @close="clearModals()" :failedTicketCash="failedTicketCash"
       :ticketObject="ticketObject" :ticketErrCode="ticketErrCode" :loadingTicket="loadingTicket" :successfulTrans="successfulTrans"
      :ticketId="ticketId" :enterMultiRedemptionMode="enterMultiRedemptionMode" :hideScanMore="hideScanMore" :isReaderScan = isReaderScan />
    <ScanTicketModal v-if="showThisScanModal" @close="showThisScanModal = false" :clearErrTicket="clearErrTicket"
      :clearTicket="clearTicket" :enterTicket="enterTicket" />
    <PlayerCardModal v-if="showPlayerCardModal" @close="showPlayerCardModal = false"
      :onPlayerCardEntered="onPlayerCardEntered" />
    <AddTransactionModal v-if="showAddTransModal" @close="showAddTransModal = false" :successfulTrans="successfulTrans"
      :errorTrans="errorTrans" :userName="userName" />
    <AttendantCalledModal v-if="attendantCalledModal" @close="attendantCalledModal = false" :closeAttendantModal="closeAttendantModal" />
    <FundChangeModal v-if="showFundChangeModal" @close="showFundChangeModal = false" :userName="userName" />
    <TransactionHistoryModal v-if="showTransHistoryModal" @close="showTransHistoryModal = false"
      :onBarcodeEntered="onBarcodeEntered" :userName="userName" />
    <v-dialog v-model="transAlertModal" max-width="400" persistent transition="none">
      <v-card>
        <v-card-title v-if="transAlertError" class="headline red--text">Error! <br />{{ errorType
        }}</v-card-title>
        <v-card-title v-else class="headline green--text">Transaction Complete!</v-card-title>
        <v-card-text v-if="transAlertError">
          please try again later or contact admin
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="green darken-1" class="white--text ml-2" @click="
            (transAlertError = false),
            (transAlertModal = false),
            clearReceipts(),
            (errorType = '')
          ">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn elevation="0" v-if="!$vuetify.theme.dark" color="info" class="mr-2" :large="$vuetify.breakpoint.xl"
      :small="!$vuetify.breakpoint.xl" fab @click="darkMode">
      <v-icon :large="$vuetify.breakpoint.xl" class="mr-1">mdi-moon-waxing-crescent</v-icon>
    </v-btn>
    <v-btn elevation="0" v-else color="info" :large="$vuetify.breakpoint.xl" :small="!$vuetify.breakpoint.xl" fab
      @click="darkMode" class="mr-2">
      <v-icon :large="$vuetify.breakpoint.xl" color="yellow">mdi-white-balance-sunny</v-icon>
    </v-btn>
    <v-btn elevation="0" color="info" v-if="helpBtnOn" class="mr-2" :large="$vuetify.breakpoint.xl"
      :small="!$vuetify.breakpoint.xl" fab @click="helpDialog = true">
      <v-icon :large="$vuetify.breakpoint.xl" class="mr-1">mdi-help-circle</v-icon>
    </v-btn>
    <v-btn elevation="0" v-if="hasFeature('newNavigation')" x-large color="petrol" class="mr-2 text-xl-h5 px-xl-8 px-3"
      dark :outlined="$vuetify.breakpoint.xl" height="85%" @click="setMeetingsModal(true)">
      <v-icon :x-large="$vuetify.breakpoint.xl" class="mr-xl-6 mr-2">mdi-horseshoe</v-icon>Tracks
    </v-btn>
    <v-btn elevation="0" v-if="!getPlayerCardId && showPlayerCardBtn" x-large :outlined="$vuetify.breakpoint.xl"
      height="85%" color="purple overline" class="mr-2 text-xl-h6 px-xl-8 px-4" dark @click="clickPlayerCard">
      <v-icon :x-large="$vuetify.breakpoint.xl" class="mr-xl-6 mr-2">mdi-card-account-details-outline</v-icon>Player
      <br />Card
    </v-btn>
    <v-btn elevation="0" v-if="getPlayerCardId && showPlayerCardBtn" x-large height="85%" color="yellow darken-4 overline"
      class="mr-2 px-xl-8 px-4" dark @click="clearPlayerCardId">
      <v-icon :x-large="$vuetify.breakpoint.xl" class="mr-xl-6 mr-2">mdi-card-account-details-star-outline</v-icon>Clear
      <br />
      Player <br />
      Card
    </v-btn>
    <v-btn elevation="0" x-large color="success overline" dark :outlined="$vuetify.breakpoint.xl" height="85%"
      class="text-xl-h6 px-xl-8 px-4" @click="clickScan">
      <v-icon :x-large="$vuetify.breakpoint.xl" class="mr-xl-6 mr-2">mdi-barcode-scan</v-icon>Manual <br />Ticket
      <br />Punch
    </v-btn>
    <v-dialog v-model="helpDialog" @keydown.esc="helpDialog = false">
      <v-btn elevation="0" class="ma-4" color="error" fab @click="helpDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-img contain src="../assets/img/helpinfo.png"></v-img>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import ScannedTicketModal from "./ScannedTicketModal";
import PlayerCardModal from "./PlayerCardModal";
import ScanTicketModal from "./ScanTicketModal";
import AddTransactionModal from "./AddTransactionModal";
import FundChangeModal from "./FundChangeModal";
import TransactionHistoryModal from "./TransactionHistoryModal";
import AttendantCalledModal from "./AttendantCalledModal.vue";
import axios from "axios";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import {CALLATTENTDANT, logo} from "../common/constants";
import { generateBrandImage } from "../common/tickets";
import {
  PLAYERCARDACTIVE,
  HELPBTNON,
  NETWORKSTATUS,
  ACCOUNTDEP,
} from "../common/constants";
import { format } from "date-fns";
import { updateCustomerDisplayScannedTickets } from "../common/customerDisplay";
import moment from "moment";
import MultiScannedTicketsModal from "./MultiScannedTicketsModal.vue";
import { generatePayoutReceipt } from "../common/tickets";
import Vue from "vue";
import { debounce } from "../common/methods";

export default {
  created() {
    this.isOnline = navigator.onLine;
    this.currentTime();
    this.currentNetStatus();
  },
  mounted() {
    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init(this.vueBarCodeScannerCallBack);
    if (
      window.rt?.onTicketScanEvent &&
      !this.showPlayerCardModal &&
      window.rt?.printImage
    ) {
      console.log("register ticket scan handler");
      this.ticketScanHandler = window.rt.onTicketScanEvent((scan) => {
        //set isReaderScan to true when ticket scanned via rt reader
        this.isReaderScan = true;
        //this won't be called twice anymore after the fix on destroyed lifecycle
        console.log("calling onBarcodeEntered from ticket scanhandler");
        this.debouncedBarcodeEntered(scan, true);
      });
    }
    if (window.rt?.onGetWrapperVersionEvent) {
      window.rt.onGetWrapperVersionEvent((version) => {
        this.$store.commit("setWrapperVersion", version);
      });
    }
  },
  destroyed() {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy();
    if (window.rt) {
      console.log("removing the ticket handler");
      window.rt.removeTicketScanEventHandler(this.ticketScanHandler);
    }
  },
  data() {
    return {
      showThisScanModal: false,
      showPlayerCardModal: false,
      showTransHistoryModal: false,
      showThisScannedTicketModal: false,
      ticketErrCode: null,
      showAddTransModal: false,
      showFundChangeModal: false,
      transAlertModal: false,
      transAlertError: false,
      ticketObject: {},
      ticketId: "",
      printed: false,
      isReaderScan: false,
      ticketScanHandler: false,
      setNewTime: "",
      errorType: "",
      loadingTicket: false,
      helpDialog: false,
      hideScanMore: false,
      debouncedBarcodeEntered: debounce(this.onBarcodeEntered),
      isOnline: false,
      attendantCalledModal: false,
    };
  },
  computed: {
    ...mapGetters([
      "getTerminalId",
      "hasFeature",
      "getTerminalLocation",
      "getTerminalBranch",
      "getPlayerCardId",
      "getVenueName",
      "getScannedTickets",
      "getMultiRedemptionMode",
      "getWrapperVersion",
    ]),
    ...mapState(["appVersion", "attendantCalled"]),
    callAttendantOn() {
      const venue = this.getVenueName
      if (CALLATTENTDANT[venue]) return true
      return false
    },
    isAttendantCalled() {
      return this.attendantCalled
    },
    imageUrl() {
      return logo[this.$route.query.venue];
    },
    showPlayerCardBtn() {
      if (PLAYERCARDACTIVE[this.$route.query.venue]) return true;
      return false;
    },
    helpBtnOn() {
      const venue = this.getVenueName;
      return HELPBTNON[venue];
    },
    netStatusOn() {
      return NETWORKSTATUS[this.getVenueName];
    },
    accDepsOn() {
      return ACCOUNTDEP[this.getVenueName];
    },
  },
  props: {
    signedIn: Boolean,
    userName: String,
    enteredTicketId: String,
    signOut: Function,
  },
  components: {
    ScannedTicketModal,
    ScanTicketModal,
    AddTransactionModal,
    FundChangeModal,
    TransactionHistoryModal,
    PlayerCardModal,
    MultiScannedTicketsModal,
    AttendantCalledModal,
  },
  methods: {
    ...mapActions([
      "setMeetingsModal",
      "clearTransactionReceipt",
      "setPlayerCardId",
      "clearPlayerCardId",
      "updateScannedTickets",
      "updateMultiRedemptionMode",
      "getTerminalToken",
      "updateAttendantCalled"
    ]),
    ...mapMutations(["setPrintedBets"]),
    closeApp() {
      window.bmElectron.send("close-app", "closingApp");
    },
    callAttendant() {
      this.attendantCalledModal = true
    },
    cancelCallAttendant() {
      if (window.onewatch) {
        window.onewatch.cancelCallAttendant()
      }
      this.updateAttendantCalled(false)
    },
    closeAttendantModal() {
      this.attendantCalledModal = false
      this.updateAttendantCalled(true)
    },
    currentTime() {
      setInterval(this.formatTime, 1000);
    },
    currentNetStatus() {
      setInterval(() => {
        this.isOnline = navigator.onLine;
      }, 1000);
    },
    formatTime() {
      const time = format(Date.now(), "pp");
      this.setNewTime = time;
    },
    onBarcodeEntered(barcode, isFromScan = false) {

      if (!this.loadingTicket) {
        this.enterTicket(barcode, isFromScan);
      }
      //show scanned ticket modal only if in single ticket mode
      if (!this.getMultiRedemptionMode && ! this.transAlertError) {
        this.showThisScannedTicketModal = true;
        this.hideScanMore = !isFromScan;
      }
    },
    vueBarCodeScannerCallBack(barcode) {
      this.onBarcodeEntered(barcode, true);
    },
    onPlayerCardEntered(barcode) {
      //do something here
      this.setPlayerCardId(barcode);
      this.showPlayerCardModal = false;
    },
    getTicketVersion(v) {
      if (v.length > 15) {
        const value = v.at(-1);
        return Number(value);
      }
      return 0; //default version
    },
    async fetchTicketDetails(ticketId, version = 0) {
      const token = await this.getTerminalToken();
      const response = await axios.post(
        `${process.env.VUE_APP_LEDGER_ENDPOINT}public/GetTicket`,
        {
          terminal_id: token,
          ticket_id: ticketId,
          version: version
        }
      );

      return response
    },
    //as this is shared method, we don't want to show ticket details in customer display when opening from transaction history
    //so add a flag "isFromScan" here to control it
    async enterTicket(v, isFromScan = false) {
      try {
        this.loadingTicket = true;
        this.clearTicket();
        if(!v){
          this.errorTrans('Unable to scan ticket');
          this.clearModals();
          this.loadingTicket = false;
          return
        }
        const ticketDashed = v
          .replace(/(\d{4})(\d{4})(\d{3})(\d{1})/, "$1-$2-$3-$4")
          .trim();
        this.ticketId = ticketDashed.substring(0, 15); //without version
        let ticketVersion = this.getTicketVersion(ticketDashed) //get ticket version from inputs(e.g. from scan barcode)

        let response = await this.fetchTicketDetails(this.ticketId, ticketVersion)

        //when click ticket from trans history, or input the ticket id manually
        //there is no version info, so need to correct the version here and call get ticket with correct version
        if (!isFromScan && response.data?.version > ticketVersion) {
          ticketVersion = response.data.version
          response = await this.fetchTicketDetails(this.ticketId, ticketVersion)
        }
        this.ticketObject = response.data;
        if (response.data.success == false ) {
            this.errorTrans(response.data.error);
            this.clearModals();
        } else {
          //ticket is valid, win/no win/already cashed/ unresulted
          //process only if not been processed yet
          if (
            isFromScan &&
            this.getScannedTickets.findIndex(
              (t) => t.ticketId == ticketDashed
            ) < 0
          ) {
            //update customer display with scanned tickets
            let tickets = this.getScannedTickets;
            tickets.unshift({ ...this.ticketObject, ticketId: ticketDashed });
            this.updateScannedTickets(tickets);
            updateCustomerDisplayScannedTickets(this.getScannedTickets);
            //process the ticket directly if in multi redemption mode
            if (this.getMultiRedemptionMode) {
              await this.processScannedTicketInMultiRedemption();
            }
          }
          if (!this.getMultiRedemptionMode) {
            this.clearTicket();
          }
        }
      } catch (err) {
        this.loadingTicket = false;
        const error = { ...err?.response?.data, enteredid: v };
        this.ticketObject = error;
        this.clearErrTicket(err);
        this.eject();
        console.log(error);
        //just in case, we need to set loadingTicket back to false if anything unexpected happened.
      }
      this.loadingTicket = false;
    },
    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    clickPlayerCard() {
      this.showPlayerCardModal = true;
    },
    clickScan() {
      this.showThisScanModal = true;
    },
    checkForUpdate() {
      window.rt?.checkForUpdate();
    },
    clearTicket() {
      this.showThisScanModal = false;
      if (!this.getMultiRedemptionMode) {
        this.showThisScannedTicketModal = true;
      }
      this.ticketErrCode = null;
    },
    clearErrTicket(ticketErrCode) {
      this.showThisScanModal = false;
      this.showThisScannedTicketModal = true;
      this.ticketErrCode = ticketErrCode;
    },
    clearModals() {
      if (!this.getMultiRedemptionMode) {
        this.updateScannedTickets([]);
      }
      updateCustomerDisplayScannedTickets(this.getScannedTickets);
      this.eject();
      this.showThisScannedTicketModal = false;
      this.ticketObject = {};
      this.ticketErrCode = null;
      this.hideScanMore = false;
    },
    eject() {
      if (this.isReaderScan) {
        console.log("trying to eject");
        window.rt.eject();
      }
      // set is ReaderScan back to false
      this.isReaderScan = false;
    },
    errorTrans(type) {
      this.transAlertError = true;
      this.transAlertModal = true;
      this.errorType = type;
    },
    failedTicketCash(type) {
      this.eject();
      this.errorTrans(type);
    },

    async successfulTicketCash(payout, type) {
      // do branding stuff only if the ticket been scanned via rt reader
      if (this.isReaderScan) {
        if (type === "refund") {
          const action = "REFUNDED";
          await window.rt.brandImageBackward(
            generateBrandImage(action, payout, this.userName)
          );
          window.rt.eject();
        } else {
          const action = "CASHED";
          await window.rt.brandImageBackward(
            generateBrandImage(action, payout, this.userName)
          );
          window.rt.eject();
        }
      }
      this.successfulTrans();
    },
    formatStartTime: function (date) {
      return moment(date, "YYYY-MM-DD H:mm:ss").format("LLL");
    },
    successfulTrans() {
      //show transaction completed modal in single ticket mode only
      if (!this.getMultiRedemptionMode) {
        this.transAlertModal = true;
      }
      this.transAlertError = false;
      this.clearModals();
    },
    clearReceipts() {
      this.clearTransactionReceipt();
    },
    //switch from single mode to multi redemption mode, then add trasanction for current scanned win ticket
    async enterMultiRedemptionMode() {
      this.showThisScannedTicketModal = false;
      this.hideScanMore = false;
      this.updateMultiRedemptionMode(true);
      await this.processScannedTicketInMultiRedemption();
      this.ticketObject = {};
      this.ticketErrCode = null;
    },
    //method to process ticket in multi redemption mode once ticket scanned
    async processScannedTicketInMultiRedemption() {
      const branch = this.ticketObject.masterBranch;
      const cap = this.ticketObject.branchCap;
      const payout = this.ticketObject.balance;

      //if ticket has no payoutowing, eject and return
      if (
        !this.ticketObject.balance ||
        (!this.ticketObject.isVoucher && payout > cap && branch !== this.getTerminalBranch)
      ) {
        console.log("eject attempt");
        this.eject();
        return;
      }
      // otherwise add transaction for win ticket or refund scratched ticket
      const token = await this.getTerminalToken();
      let payload = {
        terminal_token: token,
        amount: this.ticketObject.balance,
        ticket_id: this.ticketId,
        version: this.ticketObject.version
      };
      await axios
        .post(
          `${process.env.VUE_APP_LEDGER_ENDPOINT}public/RedeemTicket`,
          payload
        )
        .then(() => {
          console.log("payout processed");
          this.successfulTicketCash(
            this.ticketObject.balance,
            !this.ticketObject.isVoucher && this.ticketObject.detail.status === "cancelled" ? "refund" : ""
          );
        })
        .catch((e) => {
          console.log("payout not processed");
          console.log(e.message);
          //if failed, shld remove the ticket from displaying in multi ticket modal
          let tickets = this.getScannedTickets;
          tickets.splice(0, 1);
          this.updateScannedTickets(tickets);
          updateCustomerDisplayScannedTickets(this.getScannedTickets);
          this.failedTicketCash();
        });
    },

    //as in multi redemption mode, there is no re-print option, so this is only for print the win ticket
    //same behavior as the method "printThisTicket" in scannedTicketModal.vue when click on payout
    printWinTicketInMultiRedemptionMode() {
      const ticket = this.getScannedTickets[0]; //get latest ticket
      const details = ticket.detail;
      if (!details) return;
      const bet = {
        id: details.id,
        selId: details.selections[0]?.id,
        runnerNumber: details.selections[0]?.number,
        runnerName: details.selections[0]?.name,
        raceName: details.meetingName,
        trackName: details.raceName,
        trackNumber: details.raceNumber,
        stake: details.stake,
        startTime: undefined, // FIXME
        status: details.status,
        ticketId: ticket.ticketId,
        time: ticket.placedAt.seconds,
        trackCountry: "",
        winPlc: details.betType,
        odds:  parseFloat(details.odds /100) || 0,
        reprint: false,
        printed: true,
        key: details.id,
        payout: ticket.balance,
        refundOwing: undefined,
      };
      this.setPrintedBets(bet);
      if (window.rt?.printImage) {
        window.rt
          .printImage(
            generatePayoutReceipt(
              bet,
              bet.winPlc,
              this.getTerminalLocation,
              this.$route.query.venue
            )
          )
          .catch((e) => console.log(`Failed to print: ${e}`));
      } else {
        Vue.nextTick(() => {
          window.print();
        });
      }
    },
  },
};
</script>

<style scoped>
.signout {
  background-color: #ededed;
  margin: 0;
}
</style>
